import { Component, OnInit, EventEmitter, Input, Output, ViewChild, OnDestroy } from '@angular/core';
import { TabsComponent } from '../../../../shared-components/controls/tabs/tabs.component';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { EFormDesignerService } from '../e-form-designer.service';
import { EFormConfiguration } from '../../e-form-config.model';

@AutoUnsubscribe({includeArrays: true})
@Component({
  selector: 'e-form-side-panel',
  templateUrl: './e-form-side-panel.component.html',
  styleUrls: ['./e-form-side-panel.component.css']
})
export class EFormSidePanelComponent implements OnInit, OnDestroy {

  @Input() showSlideOutPanel: boolean;
  @Input() config = new EFormConfiguration();
  @Output() showSlideOutPanelChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild(TabsComponent) tabs: TabsComponent;
  tabNames = ['Controls', 'Properties', 'Tree View'];
  selectedTab = 'Controls';
  subscriptions: Subscription[] = [];
  constructor(
    private eFormDesignerService: EFormDesignerService
  ) { }

  ngOnInit() {
    this.subscriptions.push(this.eFormDesignerService.observableOpenPropertiesTabStream$.subscribe(result => {
      if (this.selectedTab != 'Properties') {
        this.selectedTab = 'Properties';
        this.tabs.clickTabWithoutEvents(this.selectedTab);
      }
    }));
    
    this.subscriptions.push(this.eFormDesignerService.observableOpenControlTabStream$.subscribe(result => {
      if (this.selectedTab == 'Properties') {
        this.selectedTab = 'Controls';
        this.tabs.clickTabWithoutEvents(this.selectedTab);
      }
    }));
  }

  closeSlideOutPanel() {
    this.showSlideOutPanel = !this.showSlideOutPanel;    
    this.eFormDesignerService.observableshowSliderPanel.next(this.showSlideOutPanel); 
  }

  selectedTabChanged(tabName: string) {
    this.selectedTab = tabName;
    this.eFormDesignerService.observableshowSliderPanelWidth.next(this.selectedTab); 
  }

  ngOnDestroy() {}

}
